import { EquipmentServiceListEdit } from './EquipmentServiceListEdit'
import { EquipmentServiceList } from './EquipmentServiceList'
import { EquipmentServiceListShow } from './EquipmentServiceListShow'

export default {
  list: EquipmentServiceList,
  edit: EquipmentServiceListEdit,
  show: EquipmentServiceListShow,
}
